import * as styles from "./SliderLabel.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import type { SliderLabelProps } from "./Slider.types";

export function SliderLabel({
  className,
  ...props
}: SliderLabelProps): JSX.Element {
  return (
    <BaseSlider.Label
      data-slot="slider-label"
      className={clsx(styles.label, className)}
      {...props}
    />
  );
}
